import { render, staticRenderFns } from "./InventorySpecimensMain.vue?vue&type=template&id=197aff31&scoped=true"
import script from "./InventorySpecimensMain.vue?vue&type=script&lang=js"
export * from "./InventorySpecimensMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aff31",
  null
  
)

export default component.exports